export const SEX = [
    {name: 'male', value: 'MASCULIN'},
    {name: 'female', value: 'FEMININ'},
    {name: 'other', value: 'AUTRE'}
];
